import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { ProofProblem } from './components/ProofProblem';
import { OfferTriage } from './components/OfferTriage';
import { MessageToMarket } from './components/MessageToMarket';
import { ProofPackSamples } from './components/ProofPackSamples';
import { AeoRepair } from './components/AeoRepair';
import { MeshRouting } from './components/MeshRouting';
import { Triskelion } from './components/Triskelion';
import { IntakeRouter } from './components/IntakeRouter';
import { Footer } from './components/Footer';

function App() {
  return (
    <main id="top" className="min-h-screen bg-obsidian text-chalk">
      <Header />
      <Hero />
      <ProofProblem />
      <OfferTriage />
      <MessageToMarket />
      <ProofPackSamples />
      <AeoRepair />
      <MeshRouting />
      <Triskelion />
      <IntakeRouter />
      <Footer />
    </main>
  );
}

export default App;
